import component from "./Offer";
export default component;
